import type { Highlight } from '~/features/document-viewer/types/highlight';
import type { FieldValueSource } from '~/redux/api/types/sylvanus/model';

import { sylvanus } from '~/services/serviceInstances';

type GetDdeTableRowsRequest = {
  page?: number;
  pageSize?: number;
  tableId: string;
};

export type ServerDdeTableRow = {
  contract_type: string;
  dde_model_values: Record<string, ServerDdeModelValue | undefined>;
  file_type: string;
  id: string;
  name: string;
  upload_date: string;
};

type ServerDdeModelOutput = {
  field_values?: ServerDdeModelOutput[];
  highlights?: Highlight[];
  output_type?: string;
  source?: FieldValueSource | null;
  sources?: FieldValueSource[] | null;
  value?: string | string[];
  value_type?: string;
};

export type ServerDdeModelValue = {
  error?: string;
  error_message?: string;
  field_title?: string;
  output?: ServerDdeModelOutput;
  prompt_model_id?: string;
  source_content?: {
    content?: string;
    highlight?: string;
    page_number?: number;
  };
  status?: string;
  value?: string;
  version_number?: number;
};

type ServerDdeModel = {
  configuration: Record<string, unknown>;
  dde_model_id: string;
  name: string;
  version_number: number;
};

type ServerDdeTableRowsResponse = {
  dde_models: ServerDdeModel[];
  rows: ServerDdeTableRow[];
  page: number;
  page_size: number;
  total_count: number;
};

export type DdeModel = {
  configuration?: Record<string, unknown>;
  id: string;
  name: string;
};

export type DdeTableRows = {
  ddeModels: DdeModel[];
  rows: ServerDdeTableRow[];
  page: number;
  pageSize: number;
  totalCount: number;
};

export const getDdeTableRows = async ({
  page = 1,
  pageSize = 100,
  tableId,
}: GetDdeTableRowsRequest): Promise<DdeTableRows> => {
  const response = await sylvanus.get<ServerDdeTableRowsResponse>(
    `/dde/table/${tableId}/rows`,
    {
      params: {
        page,
        page_size: pageSize,
      },
    },
  );

  return {
    ddeModels: (response.dde_models ?? [])
      .filter((model) => Boolean(model?.dde_model_id))
      .map((model) => ({
        configuration: model.configuration,
        id: model.dde_model_id,
        name: model.name ?? '',
      })),
    rows: response.rows ?? [],
    page: response.page,
    pageSize: response.page_size,
    totalCount: response.total_count,
  };
};
